import { handleActions } from 'redux-actions';
import update from 'immutability-helper';
import { get } from 'lodash';

import { TOGGLE_SURVEY_PREVIEW_EDITOR_HEADER } from '../constants/SurveyPreviewHeaderActions';

const initialState = {
  hasEditorHeader: true,
};

export default handleActions(
  {
    [TOGGLE_SURVEY_PREVIEW_EDITOR_HEADER]: (
      state,
      { payload: hasEditorHeader },
    ) =>
      update(state, {
        hasEditorHeader: { $set: hasEditorHeader },
      }),
  },
  initialState,
);

export const hasEditorHeader = state => get(state, 'hasEditorHeader');
